import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 py-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Sales Statistics"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold fs-7" }, "Recent sales statistics")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body p-0 d-flex flex-column" }
const _hoisted_7 = { class: "card-px pt-5 pb-10 flex-grow-1" }
const _hoisted_8 = { class: "row g-0 mt-5 mb-10" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "d-flex align-items-center me-2" }
const _hoisted_11 = { class: "symbol symbol-50px me-3" }
const _hoisted_12 = { class: "symbol-label bg-light-info" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-info" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-4 text-dark fw-bolder" }, "$2,034"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "Author Sales")
], -1)
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "d-flex align-items-center me-2" }
const _hoisted_17 = { class: "symbol symbol-50px me-3" }
const _hoisted_18 = { class: "symbol-label bg-light-danger" }
const _hoisted_19 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-4 text-dark fw-bolder" }, "$706"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "Commision")
], -1)
const _hoisted_21 = { class: "row g-0" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "d-flex align-items-center me-2" }
const _hoisted_24 = { class: "symbol symbol-50px me-3" }
const _hoisted_25 = { class: "symbol-label bg-light-success" }
const _hoisted_26 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-4 text-dark fw-bolder" }, "$49"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "Average Bid")
], -1)
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "d-flex align-items-center me-2" }
const _hoisted_30 = { class: "symbol symbol-50px me-3" }
const _hoisted_31 = { class: "symbol-label bg-light-primary" }
const _hoisted_32 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-4 text-dark fw-bolder" }, "$5.8M"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "All Time Sales")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown1 = _resolveComponent("Dropdown1")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Color-profile.svg" })
                  ])
                ])
              ]),
              _hoisted_14
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Home/Library.svg" })
                  ])
                ])
              ]),
              _hoisted_20
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("span", _hoisted_26, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Cart3.svg" })
                  ])
                ])
              ]),
              _hoisted_27
            ])
          ]),
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("span", _hoisted_32, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Barcode-read.svg" })
                  ])
                ])
              ]),
              _hoisted_33
            ])
          ])
        ])
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-6-chart card-rounded-bottom",
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: _ctx.chartHeight,
        type: "area"
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}